import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import CircularProgress from '@material-ui/core/CircularProgress';

import { COLOR } from 'assets/styles/colors';

import { Wrapper } from './styles';

/**
 * ## Loading ##
*/

const Loading = ({ bg, height }) => {
  useEffect(() => {
    document.body.style.overflowY = 'hidden';

    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, []);

  return (
    <Wrapper
      bg={bg}
      height={height}
    >
      <CircularProgress style={{ color: '#2B938A' }} />
    </Wrapper>
  );
};

Loading.defaultProps = {
  bg: COLOR.GREEN_1,
  height: '100vh',
};

Loading.propTypes = {
  bg: PropTypes.string,
  height: PropTypes.string,
};

export default Loading;
